import {
    START_COMPARABLE_REQUEST,
    START_COMPARABLE_SUCCESS,
    START_COMPARABLE_FAILURE,
    PING_COMPARABLE_REQUEST,
    PING_COMPARABLE_SUCCESS,
    PING_COMPARABLE_FAILURE,
    CANCEL_COMPARABLE_REQUEST,
    CANCEL_COMPARABLE_SUCCESS,
    CANCEL_COMPARABLE_FAILURE,
    EXPORT_COMPARABLE_REQUEST,
    EXPORT_COMPARABLE_SUCCESS,
    EXPORT_COMPARABLE_FAILURE
} from './Types';

import {
    SET_FORM_PROPERTIES,
    SET_AREA_FACET,
    SET_AREA_FACET_VALUE,
    SET_AREA_GEOJSON,
    SET_AREA_CRITERIA,
    SET_AREA_LAYER
} from '../search_area/Types';

import { COMPARABLE_REDUCER } from '../ReducerNames';
import areaReducer from '../search_area/Reducer';
import { IComparableAction, IComparableReducerState } from './comparableTypes';

const defaultCriteria = {
    id: 'root',
    type: 'group',
    conjunction: 'and',
    not: false,
    children: []
};

const defaultState = {
    isRunning: false,
    isPinging: false,
    isCancelling: false,
    isExporting: false,
    comparable: null, // The current comparable running in the background
    isComparableDirty: false,
    comparableArea: areaReducer(COMPARABLE_REDUCER)(undefined, {}),
    error: null
};

export default function reducer(
    state: IComparableReducerState = defaultState,
    action: IComparableAction
) {
    switch (action.type) {
        case START_COMPARABLE_REQUEST:
            return {
                ...state,
                isRunning: true,
                comparable: null, // Looks cleaner clearing at moment, may be best to leave in case user cancels so previous results are retained?
                error: null
            };
        case START_COMPARABLE_SUCCESS:
            return {
                ...state,
                comparable: action.comparable,
                isComparableDirty: false,
                error: null
            };
        case START_COMPARABLE_FAILURE:
            return {
                ...state,
                isRunning: false,
                isComparableDirty: true,
                error: action.error
            };
        case PING_COMPARABLE_REQUEST:
            return {
                ...state,
                isPinging: true,
                error: null
            };
        case PING_COMPARABLE_SUCCESS:
            return {
                ...state,
                isRunning: ['ready', 'queued', 'running'].includes(
                    action.comparable.status
                ),
                isPinging: false,
                comparable: action.comparable,
                isComparableDirty: false,
                error:
                    action?.comparable?.computedData &&
                    action?.comparable?.computedData?.error
                        ? action.comparable.computedData.error
                        : null
            };
        case PING_COMPARABLE_FAILURE:
            return {
                ...state,
                isRunning: false,
                isPinging: false,
                error: action.error
            };
        case CANCEL_COMPARABLE_REQUEST:
            return {
                ...state,
                isCancelling: true,
                error: null
            };
        case CANCEL_COMPARABLE_SUCCESS:
            return {
                ...state,
                isRunning: false,
                isPinging: false,
                isCancelling: false,
                isComparableDirty: true,
                comparable: null,
                error: null
            };
        case CANCEL_COMPARABLE_FAILURE:
            return {
                ...state,
                isCancelling: false,
                error: action.error
            };
        case EXPORT_COMPARABLE_REQUEST:
            return {
                ...state,
                isExporting: true,
                error: null
            };
        case EXPORT_COMPARABLE_SUCCESS:
            return {
                ...state,
                isExporting: false,
                error: null
            };
        case EXPORT_COMPARABLE_FAILURE:
            return {
                ...state,
                isExporting: false,
                error: action.error
            };
        case SET_FORM_PROPERTIES:
        case SET_AREA_FACET:
        case SET_AREA_FACET_VALUE:
        case SET_AREA_GEOJSON:
        case SET_AREA_CRITERIA:
        case SET_AREA_LAYER:
            return action.reducerName === COMPARABLE_REDUCER
                ? {
                      ...state,
                      isComparableDirty: true,
                      comparableArea: areaReducer(COMPARABLE_REDUCER)(
                          state?.comparableArea,
                          action
                      )
                  }
                : state;
        default:
            return state;
    }
}
